import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 42 42",
  class: "donut"
}
const _hoisted_2 = ["r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]

import { DonutDefinition, DonutLayer } from "@/helpers/typesDefinition";
const defaultRadius = 15.91549430918954;
const defaultStrokeWidth = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'GraphDonut',
  props: {
    donutDefinition: {}
  },
  setup(__props: any) {

const props = __props;

const circumference = (r: number) => 2 * Math.PI * r;

const getDashArray = (percentageRaw: number, r: number) => {
  const C = circumference(r);
  const p = Math.max(0, Math.min(100, percentageRaw)) / 100;
  return `${p * C} ${(1 - p) * C}`;
};

const getDashOffset = (offsetPct: number | undefined, r: number) => {
  const C = circumference(r);
  const off = (offsetPct ?? 0) / 100;
  // Start at 12 o’clock (1/4 of the circle), plus the segment's own offset
  return C * (0.25 + off);
};

const computeRadius = (layerIndex: number) => {
  const maxRadius = props.donutDefinition.maxRadius ?? defaultRadius;

  // sum of strokeWidths of all previous layers
  const shrink = props.donutDefinition.layers
    .slice(1, layerIndex + 1)
    .reduce(
      (sum: number, l: DonutLayer) =>
        sum + (l.strokeWidth ?? defaultStrokeWidth),
      0,
    );

  return maxRadius - shrink;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.donutDefinition.layers, (layer, layerIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: layerIndex }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.segments, (segment) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: segment.id
          }, [
            (!isNaN(segment.percentage))
              ? (_openBlock(), _createElementBlock("circle", {
                  key: 0,
                  class: "donut-segment",
                  cx: "21",
                  cy: "21",
                  r: computeRadius(layerIndex),
                  fill: "transparent",
                  stroke: segment.color,
                  "stroke-width": layer.strokeWidth ?? defaultStrokeWidth,
                  "stroke-dasharray": 
            getDashArray(segment.percentage, computeRadius(layerIndex))
          ,
                  "stroke-dashoffset": 
            getDashOffset(segment.offset, computeRadius(layerIndex))
          
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 64))
    }), 128))
  ]))
}
}

})